import * as ProductHelper from "helpers/ProductHelper";

export const handleRequest = async (path, method) => {
  switch (path) {
    case "/categories":
      return await handleCategories(method);
    default:
      return { message: "API not found", status: 404 };
  }
};

function handleCategories(method) {
  if (method === "GET") {
    return getCategories();
  }
  return { message: "Method not allowed", status: 405 };
}

async function getCategories() {
  const captainCategories = await ProductHelper.filterCategoriesForCaptain();

  return {
    data: captainCategories,
    message: "Category list",
    status: 200,
  };
}
